export const PROGRAM_CONTEXT_CHANGE = 'program_context_change';
export const PROGRAM_LIST_LOAD = 'program_list_load';



// WEBPACK FOOTER //
// ./src/redux/actions/types/programTypes.js